(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["list-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    /*
     * Always combine storefront filters with Shopify's variant availability
     * filter. Example:
     * filter.v.option.size=7&filter.v.availability=1
     *
     * This prevents a product from appearing for Size 7 when only its
     * Size 7 variant is sold out.
     */
    if (window.__inStockFacetGuardInitialized) return;
    window.__inStockFacetGuardInitialized = true;

    const availabilityParam = 'filter.v.availability';
    const availabilityValue = '1';

    const isCollectionOrSearchPage = () =>
      /(^|\/)collections(\/|$)/.test(window.location.pathname) ||
      /(^|\/)search(\/|$)/.test(window.location.pathname);

    const forceAvailabilityInCurrentUrl = () => {
      if (!isCollectionOrSearchPage()) return false;

      const url = new URL(window.location.href);

      if (url.searchParams.get(availabilityParam) === availabilityValue) {
        return false;
      }

      url.searchParams.set(availabilityParam, availabilityValue);
      window.location.replace(url.toString());
      return true;
    };

    if (forceAvailabilityInCurrentUrl()) return;

    const createAvailabilityInput = () => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = availabilityParam;
      input.value = availabilityValue;
      input.dataset.forceInStock = 'true';
      input.setAttribute('ref', 'facetInputs[]');
      return input;
    };

    const injectAvailabilityInput = () => {
      let foundFacetForm = false;

      document.querySelectorAll('form').forEach((form) => {
        if (!form.querySelector('facet-inputs-component')) return;

        foundFacetForm = true;

        let input = form.querySelector(
          'input[data-force-in-stock][name="filter.v.availability"]'
        );

        if (!input) {
          input = createAvailabilityInput();
          form.appendChild(input);
        }

        input.value = availabilityValue;
      });

      if (!foundFacetForm) {
        const firstFacetComponent = document.querySelector(
          'facet-inputs-component'
        );

        if (
          firstFacetComponent &&
          !firstFacetComponent.querySelector(
            'input[data-force-in-stock][name="filter.v.availability"]'
          )
        ) {
          firstFacetComponent.appendChild(createAvailabilityInput());
        }
      }
    };

    let availabilityInjectionFrame = null;

    const scheduleAvailabilityInjection = () => {
      if (availabilityInjectionFrame !== null) return;

      availabilityInjectionFrame = window.requestAnimationFrame(() => {
        availabilityInjectionFrame = null;
        injectAvailabilityInput();
      });
    };

    injectAvailabilityInput();

    const facetObserver = new MutationObserver(scheduleAvailabilityInjection);
    facetObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    const normalizeFacetSearchText = (value = '') =>
      String(value)
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/gi, '')
        .toLowerCase();

    const applyFacetValueSearch = (input) => {
      const searchComponent = input.closest('facet-value-search');
      const panel = searchComponent?.closest('.facets__inputs');
      const list = panel?.querySelector('.facets__inputs-list');

      if (!searchComponent || !list) return;

      const query = normalizeFacetSearchText(input.value);
      let visibleMatches = 0;

      list.querySelectorAll('.facets__inputs-list-item').forEach((item) => {
        const label = item.dataset.facetValueLabel || item.textContent || '';
        const matches =
          query.length === 0 || normalizeFacetSearchText(label).includes(query);

        item.hidden = !matches;

        if (matches) {
          visibleMatches += 1;
        }
      });

      const emptyMessage = searchComponent.querySelector('[data-facet-search-empty]');
      if (emptyMessage) {
        emptyMessage.hidden = visibleMatches > 0;
      }
    };

    const handleFacetSearch = (event) => {
      const input = event.target;

      if (
        !(input instanceof HTMLInputElement) ||
        !input.matches('.facets__value-search-input')
      ) {
        return;
      }

      // Run after the theme's original search handler so punctuation-insensitive
      // matching becomes the final visible state.
      window.requestAnimationFrame(() => applyFacetValueSearch(input));
    };

    document.addEventListener('input', handleFacetSearch);
    document.addEventListener('search', handleFacetSearch, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
